var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.initOk)?_c('div',[_c('router-view')],1):_c('v-app',[_c('v-main',[(_vm.initFailed)?_c('init'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }